import { FormControl } from '@angular/forms';

export function noDigitsValidator() {
  return (control: FormControl) => {
    const value = control.value;

    if (typeof value === 'string' && /\d/.test(value)) {
      return {
        noDigitsValidator: true
      };
    }

    return null;
  };
}
